import Loading from './components/loading';
import React, { lazy, Suspense } from 'react';
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Header from './components/header';
import { ConfigProvider } from 'antd';
import Footer from './components/footer';

type RouteProps = {
  path: string,
  component: any,
}

// route import for lazy render>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
const lazyRetry = (componentImport: () => Promise<any>) => {
  return new Promise<{ default: React.ComponentType<any> }>((resolve, reject) => {
    const hasRetried = window.sessionStorage.getItem('chunk-load-retried');
    componentImport()
      .then((component) => {
        window.sessionStorage.removeItem('chunk-load-retried');
        resolve(component);
      })
      .catch((error) => {
        if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
          if (!hasRetried) {
            window.sessionStorage.setItem('chunk-load-retried', 'true');
            window.location.reload();
          } else {
            window.sessionStorage.removeItem('chunk-load-retried');
            reject(error);
          }
        } else {
          reject(error);
        }
      });
  });
};

const HomePage = lazy(() => lazyRetry(() => import('./pages/home')));
const ProductsPage = lazy(() => lazyRetry(() => import('./pages/products')));
const AboutPage = lazy(() => lazyRetry(() => import('./pages/about')));
const FAQsPage = lazy(() => lazyRetry(() => import('./pages/faqs')));
const PrivacyPolicyPage = lazy(() => lazyRetry(() => import('./pages/privacy-policy')));
const TermsAndCondition = lazy(() => lazyRetry(() => import('./pages/terms-&-conditions')));
const ContactsPage = lazy(() => lazyRetry(() => import('./pages/contacts')));

const routes : RouteProps[] = [
  {
    path: "/",
    component: <HomePage />,
  },
  {
    path: "/products",
    component: <ProductsPage />,
  },
  {
    path: "/about",
    component: <AboutPage />,
  },
  {
    path: "/faqs",
    component: <FAQsPage />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-&-conditions",
    component: <TermsAndCondition />,
  },
  {
    path: "/contact",
    component: <ContactsPage />,
  },
]

function App() {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: '#515594' }, components: {} }}>
      <BrowserRouter>
        <Header />
        <Routes>
          {routes.map(({ path, component }: RouteProps) => {
            return (
              <Route
                key={path}
                path={path}
                element={<Suspense fallback={<Loading />}>{component}</Suspense>}
              />
            );
          })}
        </Routes>
        <Footer />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
